import React, { FC } from "react";
import { Stack, SxProps } from "@mui/material";

import GitHubIcon from "../Icons/github";
import XIcon from "../Icons/x";
import LinkedInIcon from "../Icons/linkedin";
import FacebookIcon from "../Icons/facebook";
import YouTubeIcon from "../Icons/youtube";
import { Colors } from "@theme/colors";
import { Colors as ColorsTwentyFive } from "@theme/colors-twentyfive";
import { uiContainerTransitionMs, uiOpacityHover } from "@src/utils";

interface Props {
  color?: string;
  size?: string;
  iconStyle?: "default" | "footer" | "ai-share" | "square";
}

const Social: FC<Props> = ({
  color = Colors.PrimaryContrast,
  size = "16px",
  iconStyle = "default",
}) => {
  let styles: SxProps = {};

  if (iconStyle === "footer") {
    styles = {
      a: {
        backgroundColor: Colors.PrimaryContainerDark,
        width: "40px",
        height: "40px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: "50px",
        opacity: 1,
        transition: `opacity ${uiContainerTransitionMs}ms ease-in-out`,
        svg: {
          width: "20px",
          height: "20px",
        },
        "&:hover": {
          opacity: uiOpacityHover,
        },
      },
    };
  }

  if (iconStyle === "ai-share") {
    color = ColorsTwentyFive.PrimaryContrast;

    styles = {
      a: {
        backgroundColor: ColorsTwentyFive.PrimaryGradient,
        width: "40px",
        height: "40px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: "50px",
        opacity: 1,
        transition: `opacity ${uiContainerTransitionMs}ms ease-in-out`,
        svg: {
          width: "20px",
          height: "20px",
        },
        "&:hover": {
          opacity: uiOpacityHover,
        },
      },
    };
  }

  if (iconStyle === "square") {
    color = ColorsTwentyFive.PrimaryContainerDark;

    styles = {
      a: {
        backgroundColor: ColorsTwentyFive.PrimaryContrast,
        width: "40px",
        height: "40px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: "8px",
        opacity: 1,
        transition: `opacity ${uiContainerTransitionMs}ms ease-in-out`,
        svg: {
          width: "20px",
          height: "20px",
        },
        "&:hover": {
          opacity: uiOpacityHover,
        },
      },
    };
  }

  return (
    <Stack
      direction="row"
      spacing={iconStyle === "default" ? 3 : "12px"}
      sx={{
        ...styles,
        justifyContent: iconStyle === "ai-share" ? "center" : "initial",
      }}
    >
      <a href="https://github.com/pangeacyber" target="_new">
        <GitHubIcon color={color} size={size} />
      </a>
      <a href="https://www.linkedin.com/company/pangea-cyber" target="_new">
        <LinkedInIcon color={color} size={size} />
      </a>
      <a href="https://x.com/PangeaCyber" target="_new">
        <XIcon color={color} size={size} />
      </a>
      <a href="https://www.facebook.com/pangeacyber" target="_new">
        <FacebookIcon color={color} size={size} />
      </a>
      <a href="https://www.youtube.com/@pangeacyber" target="_new">
        <YouTubeIcon color={color} size={size} />
      </a>
    </Stack>
  );
};

export default Social;
